module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/border_gray-8ee87933bb58066533a95ac56048eeac.png";